import map from 'lodash/map';
import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_TOURNAMENTS =
  'REQUEST_FETCH_STATS_TOURNAMENTS';
export const SUCCESS_FETCH_STATS_TOURNAMENTS =
  'SUCCESS_FETCH_STATS_TOURNAMENTS';
export const FAIL_FETCH_STATS_TOURNAMENTS = 'FAIL_FETCH_STATS_TOURNAMENTS';

export const fetchStatsTournaments = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_TOURNAMENTS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsTournaments', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_TOURNAMENTS});
        else {
          const tournaments = data.tournamentsCreationBreakdown.creations;
          const creations = map({...tournaments}, (stat, key) => {
            return {...stat, id: `creations-${key}`, date: key};
          });

          dispatch({
            type: SUCCESS_FETCH_STATS_TOURNAMENTS,
            data: {...data.tournamentsCreationBreakdown.countries, creations},
          });
        }

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_TOURNAMENTS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_TOURNAMENTS_BY_STATUS =
  'REQUEST_FETCH_STATS_TOURNAMENTS_BY_STATUS';
export const SUCCESS_FETCH_STATS_TOURNAMENTS_BY_STATUS =
  'SUCCESS_FETCH_STATS_TOURNAMENTS_BY_STATUS';
export const FAIL_FETCH_STATS_TOURNAMENTS_BY_STATUS =
  'FAIL_FETCH_STATS_TOURNAMENTS_BY_STATUS';

export const fetchStatsTournamentsByStatus = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_TOURNAMENTS_BY_STATUS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsTournamentsByStatus', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({type: FAIL_FETCH_STATS_TOURNAMENTS_BY_STATUS});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_TOURNAMENTS_BY_STATUS,
            data: data.tournamentsStatusesBreakdown.countries,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_TOURNAMENTS_BY_STATUS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_TOURNAMENTS_ROUNDS =
  'REQUEST_FETCH_STATS_TOURNAMENTS_ROUNDS';
export const SUCCESS_FETCH_STATS_TOURNAMENTS_ROUNDS =
  'SUCCESS_FETCH_STATS_TOURNAMENTS_ROUNDS';
export const FAIL_FETCH_STATS_TOURNAMENTS_ROUNDS =
  'FAIL_FETCH_STATS_TOURNAMENTS_ROUNDS';

export const fetchStatsTournamentsRounds = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_TOURNAMENTS_ROUNDS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsTournamentsRounds', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_TOURNAMENTS_ROUNDS});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_TOURNAMENTS_ROUNDS,
            data: data.tournamentsRoundsBreakdown.countries,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_TOURNAMENTS_ROUNDS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES =
  'REQUEST_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES';
export const SUCCESS_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES =
  'SUCCESS_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES';
export const FAIL_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES =
  'FAIL_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES';

export const fetchStatsTournamentsAverageSizes = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsTournamentsAverageSizes', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({type: FAIL_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES,
            data: data.tournamentsAverageSizesBreakdown.countries,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_TOURNAMENTS_AVERAGE_SIZES) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS =
  'REQUEST_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS ';
export const SUCCESS_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS =
  'SUCCESS_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS ';
export const FAIL_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS =
  'FAIL_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS ';

export const fetchStatsTournamentsActiveUsers = (
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS});
    if (onRequest) onRequest();

    fetch(getEndpoint('fetchStatsTournamentsActiveUsers'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({type: FAIL_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS,
            data: data.tournamentsActiveUsersBreakdown.countries,
          });

        if (onSuccess) onSuccess(data);
      })
      .catch((error, type = FAIL_FETCH_STATS_TOURNAMENTS_ACTIVE_USERS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};

export const REQUEST_FETCH_STATS_TOURNAMENTS_BY_USERS =
  'REQUEST_FETCH_STATS_TOURNAMENTS_BY_USERS ';
export const SUCCESS_FETCH_STATS_TOURNAMENTS_BY_USERS =
  'SUCCESS_FETCH_STATS_TOURNAMENTS_BY_USERS ';
export const FAIL_FETCH_STATS_TOURNAMENTS_BY_USERS =
  'FAIL_FETCH_STATS_TOURNAMENTS_BY_USERS ';

export const fetchStatsTournamentsByUsers = (
  payload,
  onSuccess,
  onFail,
  onRequest,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_STATS_TOURNAMENTS_BY_USERS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchStatsTournamentsByUsers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_STATS_TOURNAMENTS_BY_USERS});
        else
          dispatch({
            type: SUCCESS_FETCH_STATS_TOURNAMENTS_BY_USERS,
            data: data.tournamentsByUsersBreakdown.countries,
          });

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_STATS_TOURNAMENTS_BY_USERS) => {
        if (onFail) onFail(type, error);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/tournaments.js